import { WashingType } from './washing-type.model';
import { WearLevel } from './wear-level.model';
import { Product } from './product.model';
import { IPerson } from '../../../+common/contracts/person.model.contract';
import { LaundryInputOutput } from './laundry-input.model';
import { Phase } from './phase.model';
import { LabelType } from './label-type.model';
import { Image } from 'app/+common/model/image.model';

export class Garment
{
    id?: number;
    enabled?: boolean;
    name?: string;
    product?: Product;
    wearLevel?: WearLevel;
    washingType?: WashingType;
    washingCount?: number;
    size?: string;
    colour?: string;
    ownerId?: number;
    owner?: IPerson;
    rfid?: string;
    barcode?: string;
    movementCount?: number;
    currentPhase?: Phase;
    movementList?: LaundryInputOutput[];
    creationDate?: Date;
    lastUpdateDate?: Date;
    creationUserId?: number;
    creationUsername?: string;
    updateUserId?: number;
    updateUsername?: string;
    labelType?: LabelType;
    image?: Image;
    error?: any;
    rfidReadCount?: number
    constructor()
    {
        this.id = 0;
        this.enabled = true;
        this.name = '';
        // this.productId = 0;
        this.product = new Product();
        this.wearLevel = new WearLevel();
        this.washingType = new WashingType();
        this.currentPhase = new Phase();
        this.labelType = new LabelType();
        this.image = new Image();
        this.creationUserId = 0;
        this.updateUserId = 0;
        this.creationUsername = '';
        this.updateUsername = '';
        this.washingCount = 0;
        this.size = '';
        this.colour = '';
        this.ownerId = 0;
        this.rfid = '';
        this.barcode = '';
        this.movementCount = 0;        
        this.error = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/+core/common/model/garment.model.ts